import { render } from "./bulk_approval.vue?vue&type=template&id=7e8f218c&scoped=true&ts=true"
import script from "./bulk_approval.vue?vue&type=script&lang=ts"
export * from "./bulk_approval.vue?vue&type=script&lang=ts"

import "./bulk_approval.vue?vue&type=style&index=0&id=7e8f218c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e8f218c"]])

export default __exports__